var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Outline / Arrow-Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M18 9.50048L11.1597 16.3408L9.85493 15.0361L14.4952 10.3958L0 10.3958V8.60662L14.4966 8.60662L9.85493 3.9649L11.1597 2.66016L18 9.50048Z",
    fill: "var(--white)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightOutlined);
export default __webpack_public_path__ + "static/media/arrowRightOutlined.9c9d0fd92a174d0931fecefb64b54b53.svg";
export { ForwardRef as ReactComponent };